import { enroll, listEnrolledIds, listFeatured, listMine } from "../lib/store";
import { t } from "../lib/i18n";
import { h, mount } from "../ui/dom";
import { navigate } from "../ui/router";
import { signedIn } from "../ui/app";
import { collectionCard, spinner } from "./parts";

export async function renderBrowse(host: HTMLElement): Promise<void> {
  mount(host, h("div", { class: "screen" }, spinner()));

  // Featured is readable signed out; listMine needs a session.
  const featured = await listFeatured();
  const mine = signedIn ? await listMine() : [];
  const enrolledIds = signedIn ? await listEnrolledIds() : new Set<string>();

  const sections: HTMLElement[] = [];

  if (featured.length) {
    sections.push(
      h("section", { class: "stack" },
        h("h3", { text: t("official") }),
        ...featured.map((collection) => {
          const already = enrolledIds.has(collection.id);
          return collectionCard(collection, {
            onOpen: () => navigate(`/c/${collection.id}`),
            action: !signedIn
              ? undefined
              : already
                // Already added: label it and stop offering the action, rather
                // than letting a second tap look like it did nothing.
                ? h("span", { class: "pill fresh", text: t("added") })
                : h("button", {
                    class: "contrast small",
                    text: t("add"),
                    on: {
                      click: async (event) => {
                        event.stopPropagation(); // the row itself navigates
                        await enroll(collection.id);
                        navigate(`/c/${collection.id}`);
                      },
                    },
                  }),
          });
        }),
      ),
    );
  }

  if (signedIn) {
    sections.push(
      h("section", { class: "stack" },
        h("h3", { text: t("myCollections") }),
        ...(mine.length
          ? mine.map((collection) =>
              collectionCard(collection, { onOpen: () => navigate(`/c/${collection.id}`), owned: true }),
            )
          : [h("p", { class: "muted", text: t("noCollections") })]),
        h("button", { class: "ghost", text: t("newCollection"), on: { click: () => navigate("/browse/new") } }),
      ),
    );
  }

  mount(host, h("div", { class: "screen stack" }, h("h2", { text: t("navBrowse") }), ...sections));
}
